import { useTranslation } from 'react-i18next';

export default function Title() {
  const { t } = useTranslation('pdp');

  return (
    <div
      data-cy="wtb-title"
      className="text-title-sm flex items-center justify-between tracking-wide text-black"
    >
      {t('getNotifiedTitle')}
    </div>
  );
}
